import { classes } from "./react"

interface Props {
    setValue: (file: File) => void
    fileName: string
    className?: string
}

export function FileSelector({ setValue, fileName, className }: Props) {

    const onChange = (files: FileList) => {
        setValue(files.length === 1 ? files[0] : null)
    }

    return <div className={classes("input-group", className)}>
        <span className="input-group-btn">
            <span className="btn btn-default btn-file">
                Browse...<input type="file" onChange={e => onChange(e.target.files)} />
            </span>
        </span>
        <input type="text" className="form-control file-name" defaultValue={fileName} />
    </div>;
}
